<div class="users">
  <a [routerLink]="'/utilisateur/' + user.username.toLowerCase()" class="user" *ngFor="let user of currentUsers">
    <app-img-or-letter-picture-component class="block-picture-user"
                                [textForOneLetter]="user.username"
                                [userPicture]="user.userPicture"
    ></app-img-or-letter-picture-component>
    <div class="title">&#64;{{user.username}}</div>
  </a>
</div>
